import React, { useState } from 'react';
import LeadCaptureModal from './LeadCaptureModal';
import InfoRequestModal from './InfoRequestModal';
import ApplicationModal from './ApplicationModal';

const WhyJoinKiloterra = () => {
  const [isLeadModalOpen, setIsLeadModalOpen] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [isApplicationModalOpen, setIsApplicationModalOpen] = useState(false);

  const benefits = [
    {
      title: 'LIVE LIFE ON YOUR TERMS',
      image: '/Picture2.jpg',
      description: 'Build your business on your schedule, and earn what you\'re worth. KILOTERRA Land Specialists enjoy the flexibility and resources to get the most out of life.',
      cta: 'SPEAK TO RECRUITER',
      action: () => setIsLeadModalOpen(true)
    },
    {
      title: 'TURN YOUR PASSION INTO A CAREER',
      image: '/Picture3.jpg',
      description: 'Trade in your corporate ladder for days spent out on the farm, where you thrive, and turn your land knowledge into a rewarding career.',
      cta: 'APPLY NOW',
      action: () => setIsApplicationModalOpen(true)
    },
    {
      title: 'ACHIEVE FINANCIAL INDEPENDENCE',
      image: '/Picture1.jpg',
      description: 'We don\'t push our agents into the deep end to see who floats. We provide the tools, training, and support to ensure you exceed your financial goals.',
      cta: 'LEARN MORE',
      action: () => setIsInfoModalOpen(true)
    }
  ];

  return (
    <>
      <section id="why-join" className="py-20 relative overflow-hidden">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0 z-0">
          <img
            src="/DJI_0154_midwest land scape.jpg"
            alt="Beautiful Midwest landscape with rolling hills and autumn colors at golden hour"
            className="w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16 animate-slide-up">
            <h2 className="text-4xl font-bold text-white mb-6 uppercase">
              Why Join KILOTERRA?
            </h2>
            {/* Yellow horizontal line */}
            <div className="flex justify-center mb-6">
              <div className="w-16 h-1 bg-kiloterra-yellow"></div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-white shadow-lg p-6 text-center hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 animate-slide-up flex flex-col h-full"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className="mb-6">
                  <img
                    src={benefit.image}
                    alt={benefit.title}
                    className="w-full h-48 object-cover mb-4"
                    loading="lazy"
                  />
                </div>
                <h3 className="text-lg font-bold text-kiloterra-yellow mb-4 uppercase">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed flex-grow">
                  {benefit.description}
                </p>
                <div className="mt-auto">
                  <button 
                    onClick={benefit.action}
                    className="bg-kiloterra-yellow text-kiloterra-dark px-6 py-3 font-bold hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105 uppercase tracking-wide w-full"
                  >
                    {benefit.cta}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <LeadCaptureModal 
        isOpen={isLeadModalOpen} 
        onClose={() => setIsLeadModalOpen(false)} 
      />
      
      <InfoRequestModal 
        isOpen={isInfoModalOpen} 
        onClose={() => setIsInfoModalOpen(false)} 
      />

      <ApplicationModal 
        isOpen={isApplicationModalOpen} 
        onClose={() => setIsApplicationModalOpen(false)}
        source="why_join_kiloterra"
      />
    </>
  );
};

export default WhyJoinKiloterra;